module.exports = __webpack_public_path__ + "static/media/Bob Kelly Headshot.9e486793.jpeg";